// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage, defineMessages } from "react-intl";

export const ViewCreatorProfile = (): ReactElement => (
    <FormattedMessage
        id="apps.membership.components.viewCreatorProfile"
        description="View creator profile."
        defaultMessage="View Creator Profile"
    />
);
ViewCreatorProfile.displayName = "ViewCreatorProfile";

export const messages = defineMessages({
    sponsoredLenses: {
        id: "apps.membership.components.sponsoredLenses",
        description: "Sponsored lenses.",
        defaultMessage: "Sponsored Lenses",
    },
});
